import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

const Tabs = ({ children }) => {
    const [selectedId, setSelectedId] = useState(children[0].props.name);
    const selectedTab = children.find(tab => tab.props.name === selectedId);

    const small = useMediaQuery({query: '(max-width: 1000px)'});
    const tabViewStyle = {...styles.tabView};
    if (small) {
        tabViewStyle.paddingLeft = '15px';
        tabViewStyle.paddingRight = '15px';
    }

    return (
        <div style={styles.container}>
            <div style={styles.outerSelectorsContainer}>
                <div style={styles.selectors}>
                    {
                        children.map((tab) => {
                            let style = styles.selector;
                            if(tab.props.name === selectedId) {
                                style = {...style, ...styles.selected};
                            }
                            return (
                                <button key={tab.props.name}
                                onClick={() => setSelectedId(tab.props.name)}
                                style={style}>
                                    {tab.props.name}
                                </button>
                            );
                        })
                    }
                </div>
            </div>
            <div key={selectedId} style={tabViewStyle}>
                {selectedTab}
            </div>
        </div>
    );
};

const Tab = ({ children, name }) => (
    <div>
        {children}
    </div>
);

Tabs.Tab = Tab;

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        gap: '1.5rem',
        margin: 0,
    },
    selected: {
        textDecoration: 'underline',
        fontSize: '1.3rem'
    },
    selector: {
        whiteSpace: 'nowrap',
        scrollSnapAlign: 'center'
    },
    tabView: {
        width: '100%',
        borderRadius: '2rem',
        paddingLeft: '10%',
        paddingRight: '10%'
    },
    outerSelectorsContainer: {
        display: 'flex',
        justifyContent: 'center',
        overflowX: 'auto',
        width: '100%'
    },
    selectors: {
        display: 'flex',
        flexDirection: 'row',
        gap: '1.5rem',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '160px',
        overflowX: 'auto',
        paddingLeft: '2rem',
        paddingRight: '2rem',
        scrollSnapType: 'x mandatory',
        scrollSnapStop: 'always',
    }
};

export default Tabs;